export default __webpack_public_path__ + "static/media/clock_outline.d8436396.svg";